module.exports = __webpack_public_path__ + "img/yishi11.2c59aad6.jpg";